module.exports = __webpack_public_path__ + "img/machine.25c79513.svg";